import { SocketIOEventTypeEnum } from '@zaoblako/shared/common/enums/socketIO/socket.io.event.type.enum';

/**
 * Сопоставление типов событий и пространств имен Socket IO
 */
export const SocketIONamespaceMap: Record<SocketIOEventTypeEnum, string> = {
  [SocketIOEventTypeEnum.THREAD]: '/thread',
  [SocketIOEventTypeEnum.TASK]: '/task',
  [SocketIOEventTypeEnum.NOTIFICATION]: '/notification',
  [SocketIOEventTypeEnum.EXTERNAL_NOTIFICATION]: '/external-notification',
  [SocketIOEventTypeEnum.PROJECT]: '/project',
  [SocketIOEventTypeEnum.TEST]: '/test',
  [SocketIOEventTypeEnum.HELPDESK]: '/helpdesk',
  [SocketIOEventTypeEnum.DEAL]: '/deal',
  [SocketIOEventTypeEnum.DEALS_GROUP]: '/deals-group',
  [SocketIOEventTypeEnum.BUDGET_REQUEST]: '/budget-request',
  [SocketIOEventTypeEnum.PURCHASE]: '/purchase',
  [SocketIOEventTypeEnum.EQUIPMENT_REPORT]: '/control',
  [SocketIOEventTypeEnum.CCTV_EVENT_REPORT]: '/cctv-event-report',
};
